<template>
    <div>
        <div id="verify-account" class="wrapper m0-50 critical">
            <div class="section">
                <div class="div-block-15">
                    <div class="form-container">
                        <div class="form-block w-form">
                            <div class="input-container form-success" v-if="success">
                                <div>Thank you! Your account now is validated. Please <router-link class="link-blue" v-bind:to="'/login'">login.</router-link></div>
                            </div>
                            <div class="input-container form-fail" v-if="fail">
                                <div>Oops! Something went wrong. Please check your email for account validation link.</div>
                                <div>If you already have validated your account before. Please <router-link class="link-blue" v-bind:to="'/login'">login.</router-link></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { userService } from '../assets/js/services/userService';

    export default {
        name: "VerifyAccount",
        data() {
            return {
                success: false,
                fail: false
            }
        },
        components: {
        },
        created () {
            document.title = "Verify Account";//Set the document title
            const token = this.$route.query.token;
            if (token){
                userService.verifyAccount(token)
                    .then(() => {this.success = true;})
                    .catch(() => {this.fail = true;});
            }
            else {
                this.fail = true;
            }
        },
    }
</script>

<style scoped>

</style>
